/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class SupportService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation fixbuyercaddy314
   */
  static readonly Fixbuyercaddy314Path = '/support/buyercaddy314';

  /**
   * Fix BUYERCADDY-314.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fixbuyercaddy314()` instead.
   *
   * This method doesn't expect any request body.
   */
  fixbuyercaddy314$Response(params?: {
  }): Observable<StrictHttpResponse<{
'counter'?: number;
}>> {

    const rb = new RequestBuilder(this.rootUrl, SupportService.Fixbuyercaddy314Path, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'counter'?: number;
        }>;
      })
    );
  }

  /**
   * Fix BUYERCADDY-314.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fixbuyercaddy314$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fixbuyercaddy314(params?: {
  }): Observable<{
'counter'?: number;
}> {

    return this.fixbuyercaddy314$Response(params).pipe(
      map((r: StrictHttpResponse<{
'counter'?: number;
}>) => r.body as {
'counter'?: number;
})
    );
  }

  /**
   * Path part for operation fixTechStacksInPc
   */
  static readonly FixTechStacksInPcPath = '/support/set-tech-stacks';

  /**
   * Fix PC Data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fixTechStacksInPc()` instead.
   *
   * This method doesn't expect any request body.
   */
  fixTechStacksInPc$Response(params?: {
  }): Observable<StrictHttpResponse<{
'counter'?: number;
}>> {

    const rb = new RequestBuilder(this.rootUrl, SupportService.FixTechStacksInPcPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'counter'?: number;
        }>;
      })
    );
  }

  /**
   * Fix PC Data.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fixTechStacksInPc$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fixTechStacksInPc(params?: {
  }): Observable<{
'counter'?: number;
}> {

    return this.fixTechStacksInPc$Response(params).pipe(
      map((r: StrictHttpResponse<{
'counter'?: number;
}>) => r.body as {
'counter'?: number;
})
    );
  }

  /**
   * Path part for operation fixInstallData
   */
  static readonly FixInstallDataPath = '/support/buyercaddy-304-product-to-category';

  /**
   * Fix Install Data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fixInstallData()` instead.
   *
   * This method doesn't expect any request body.
   */
  fixInstallData$Response(params?: {
  }): Observable<StrictHttpResponse<{
'counter'?: number;
}>> {

    const rb = new RequestBuilder(this.rootUrl, SupportService.FixInstallDataPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'counter'?: number;
        }>;
      })
    );
  }

  /**
   * Fix Install Data.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fixInstallData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fixInstallData(params?: {
  }): Observable<{
'counter'?: number;
}> {

    return this.fixInstallData$Response(params).pipe(
      map((r: StrictHttpResponse<{
'counter'?: number;
}>) => r.body as {
'counter'?: number;
})
    );
  }

  /**
   * Path part for operation fixManualMatch
   */
  static readonly FixManualMatchPath = '/support/buyercaddy-304-manual-match';

  /**
   * Fix Manual Matches.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fixManualMatch()` instead.
   *
   * This method doesn't expect any request body.
   */
  fixManualMatch$Response(params?: {
  }): Observable<StrictHttpResponse<{
'counter'?: number;
}>> {

    const rb = new RequestBuilder(this.rootUrl, SupportService.FixManualMatchPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'counter'?: number;
        }>;
      })
    );
  }

  /**
   * Fix Manual Matches.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fixManualMatch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fixManualMatch(params?: {
  }): Observable<{
'counter'?: number;
}> {

    return this.fixManualMatch$Response(params).pipe(
      map((r: StrictHttpResponse<{
'counter'?: number;
}>) => r.body as {
'counter'?: number;
})
    );
  }

  /**
   * Path part for operation fixbuyercaddy346
   */
  static readonly Fixbuyercaddy346Path = '/support/buyercaddy346/{vendorId}';

  /**
   * Fix BUYERCADDY-346.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fixbuyercaddy346()` instead.
   *
   * This method doesn't expect any request body.
   */
  fixbuyercaddy346$Response(params: {
    vendorId: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SupportService.Fixbuyercaddy346Path, 'post');
    if (params) {
      rb.path('vendorId', params.vendorId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Fix BUYERCADDY-346.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fixbuyercaddy346$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fixbuyercaddy346(params: {
    vendorId: string;
  }): Observable<void> {

    return this.fixbuyercaddy346$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
